/* eslint-disable */
import axios from 'axios'
import * as vars from '@/vars.json'

const httpAxios = axios.create({
  params: {},
})

export const delivery = {
  namespaced: true,
  state: {
  },

  mutations: {
  },

  actions: {
    isDeliveryAvailable({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/disponibilidadFlota', payload).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        });
      });
    },
    deliveryCost({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/costoMandaos', payload).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        });
      });
    },
    createService({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/crearMandaos', payload).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        });
      });
    },
    deliveryStatus({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/historialMandaos', payload).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        });
      });
    },

  },

  getters: {
  },
}
